import axios from "axios";

export default class MetadataService {
  constructor() {}

  static getFeatureClassNameFromMetadataRecord(restAddress, restIndex) {
    return new Promise((resolve, reject) => {
      restAddress = restAddress.substring(restAddress.indexOf("/services"));
      axios
        .get(
          process.env.VUE_APP_METADATA_MAP_SERVICE_URL +
            process.env.VUE_APP_METADATA_SERVICES_LAYER_ID +
            "/query?",
          {
            params: {
              where:
                "restAdress LIKE '%" +
                restAddress +
                "%' AND restIndex=" +
                restIndex +
                "",
              outFields: "featureClass, restName",
              f: "json"
            }
          }
        )
        .then(result => {
          if (result.data.features.length === 0) {
            resolve(false);
          }
          resolve(result.data.features[0].attributes.featureClass);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static getFeatureClassMetadata(featureClass) {
    return axios.get(
      process.env.VUE_APP_METADATA_MAP_SERVICE_URL +
        process.env.VUE_APP_METADATA_KARTLAG_LAYER_ID +
        "/query?",
      {
        params: {
          where: "featureClass = '" + featureClass + "'",
          outFields: "*",
          f: "json"
        }
      }
    );
  }

  static getAttributeMetadataForFeatureClass(featureClass) {
    return axios.get(
      process.env.VUE_APP_METADATA_MAP_SERVICE_URL +
        process.env.VUE_APP_METADATA_DATASETT_LAYER_ID +
        "/query?",
      {
        params: {
          where: "featureClass = '" + featureClass + "'",
          outFields: "*",
          f: "json"
        }
      }
    );
  }

  static createMetadataObject(
    featureClassMetadata,
    featureClassAttributeMetadata
  ) {
    let newLayerMetadata = {
      urls: [],
      felter: []
    };

    let attributes = featureClassMetadata.data.features[0].attributes;

    newLayerMetadata.beskrivelse =
      featureClassMetadata.data.features[0].attributes.beskrivelse;

    newLayerMetadata.thumbnailUrl =
      process.env.VUE_APP_METADATA_THUMBNAILS_URL + attributes.thumbnail;

    newLayerMetadata.urls.push({
      url: attributes.url1,
      text: attributes.url1_text
    });
    newLayerMetadata.urls.push({
      url: attributes.url2,
      text: attributes.url2_text
    });
    newLayerMetadata.urls.push({
      url: attributes.url3,
      text: attributes.url3_text
    });

    featureClassAttributeMetadata.data.features.forEach(feature => {
      if (feature.attributes.link && feature.attributes.atlas) {
        newLayerMetadata.felter.push(feature.attributes);
      }
    });

    return newLayerMetadata;
  }

  static loadMetadata(layer) {
    return this.getFeatureClassNameFromMetadataRecord(
      layer.restAdress,
      layer.restIndex
    ).then(featureClassName => {
      if (featureClassName === false) {
        return false;
      }
      return this.getFeatureClassMetadata(featureClassName).then(
        featureClassMetadata => {
          let featureClass =
            featureClassMetadata.data.features[0].attributes.featureClass;

          return this.getAttributeMetadataForFeatureClass(featureClass).then(
            featureClassAttributeMetadata => {
              let metadataObject = this.createMetadataObject(
                featureClassMetadata,
                featureClassAttributeMetadata
              );

              metadataObject.restAdress = layer.restAdress;
              metadataObject.restIndex = layer.restIndex;

              return metadataObject;
            }
          );
        }
      );
    });
  }
}
